import styled from 'styled-components';
import { colors, toRgba } from '@/styles';

export const CommitOption = styled.div`
  .commitRef {
    font-family: var(--font-family-mono);
  }
  .commit-message {
    font-size: 0.8rem;
    margin: 5px -10px 0;
    padding: 5px 12px 0;
  }
  .commit-date {
  }
`;
